import { render, staticRenderFns } from "./AddExchangeTruckModal.vue?vue&type=template&id=2552bffa&scoped=true"
import script from "./AddExchangeTruckModal.vue?vue&type=script&lang=js"
export * from "./AddExchangeTruckModal.vue?vue&type=script&lang=js"
import style0 from "./AddExchangeTruckModal.vue?vue&type=style&index=0&id=2552bffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2552bffa",
  null
  
)

export default component.exports